'use strict'

export default class ModelController {

  /*@ngInject*/
  constructor ($http, $state, $scope) {
    this.$http = $http
    this.$state = $state
    this.$scope = $scope
  }

  $onInit () {
    this.getData()
  }

  getData () {
    this.$http.get(`/api/myScriptModels`).then(res => {
      this.data = res.data
    })
  }

  delete (id) {
    if (confirm('确定？')) {
      this.$http.delete('api/myScriptModels/' + id).then(response => {
        this.getData()
      })
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/myscripts/model/model.controller.js